(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){


var TheChurchCo_Utils = require('./modules/Utils');
var TheChurchCo_PageBuilder = require('./modules/page-builder');
var TheChurchCo_FlyIO = require('./modules/flyio-ssl')
var TheChurchCo_NewContent = require('./modules/new-content');
// ------------------------------------
// Vue
// ------------------------------------

// Blogs & Podcast Importer
require('./vue/admin-importer.js')

// Instagram Admin Options
require('./vue/instagram-options.js')



// ------------------------------------
// jQuery Modules
// ------------------------------------

var TheChurchCo_Dashboard = require('./modules/dashboard');

jQuery(document).ready(function($) {

	// Remove The Sidebar and such
	TheChurchCo_Dashboard.init();
	TheChurchCo_PageBuilder.init();
	TheChurchCo_FlyIO.init();
	TheChurchCo_NewContent.init();

});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_c666c552.js","/")